import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { CommonService } from '../../common-service';
import { environment } from '../../../../../environments/environment';
import { SearchResponse } from '../../responses/platform/search.response';
import { SearchRequest } from '../../requests/platform/search.request';

export interface CategoryItem {
  idCategory: number;
  categoryName: string;
}

@Injectable({
  providedIn: 'root',
})
export class SearchService extends CommonService {
  constructor(
    private httpClient: HttpClient
  ) {
    super();
  }

  public get(searchRequest: SearchRequest): Observable<SearchResponse> {
   
    let url:string = `${environment.urlApiPlatform}Search?text=${searchRequest.text}&includesEbook=${searchRequest.includesEbook}&includesBook=${searchRequest.includesBook}&page=${searchRequest.page}`;
    if(searchRequest.idBookSelected){
      url += `&idBookSelected=${searchRequest.idBookSelected}`;
    }
    if(searchRequest.minPrice){
      url += `&minPrice=${searchRequest.minPrice}`;
    }
     if(searchRequest.maxPrice){
      url += `&maxPrice=${searchRequest.maxPrice}`;
    }
    if(searchRequest.isbn){
      url += `&isbn=${encodeURIComponent(searchRequest.isbn)}`;
    }
    if(searchRequest.authorName){
      url += `&authorName=${encodeURIComponent(searchRequest.authorName)}`;
    }
    if(searchRequest.categories && searchRequest.categories.length > 0){
      searchRequest.categories.forEach(catId => {
        url += `&categories=${catId}`;
      });
    }
    return this.httpClient.get<SearchResponse>(url)
      .pipe(catchError(this.handleError));
  }

  public getCategories(): Observable<CategoryItem[]> {
    return this.httpClient.get<CategoryItem[]>(`${environment.urlApiPlatform}Search/categories`)
      .pipe(catchError(this.handleError));
  }
}
